import { Typography } from "../../../typography";
import { Avatar, AvatarFallback, AvatarImage } from "../../../avatar";
import { CitationComponent as TCitationComponent } from "@aichat/types/socket/widget.types";

function CitationComponent({
  url,
  domainName,
  favicon,
  title,
}: TCitationComponent) {
  return (
    <a
      target="_blank"
      href={url}
      className="max-w-[176px] transition-colors duration-150 rounded-sm shrink-0 w-fit p-3 bg-background-100 hover:bg-background-200 focus:bg-background-200 flex flex-col gap-2"
    >
      <Typography variant="subtleMedium" className="line-clamp-1 text-ellipsis">
        {title}
      </Typography>
      <div className="flex items-center gap-2">
        <Avatar className="size-4 bg-black">
          <AvatarImage src={favicon} className="rounded-full" />
          <AvatarFallback className="bg-black text-white text-[8px]">
            {domainName.at(0)?.toUpperCase()}
            {domainName.at(1)?.toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <Typography
          variant="detail"
          className="text-muted-foreground overflow-hidden text-ellipsis max-w-[130px]"
        >
          {domainName}
        </Typography>
      </div>
    </a>
  );
}

export default CitationComponent;
